import { combineReducers } from '@reduxjs/toolkit'
import maternityCenterUserReducer from './maternityCenterUserSlice'
import systemRoleReducer from './systemRoleSlice'
import systemPermissionReducer from './systemPermissionSlice'
import systemAgentReducer from './systemAgentSlice'

const useStore = combineReducers({
  maternityCenterUser: maternityCenterUserReducer,
  systemRole: systemRoleReducer,
  systemPermission: systemPermissionReducer,
  systemAgent: systemAgentReducer
})

export default useStore
